export default {
  contact_provider: 'Kontakt din udbyder for at aktivere dette.',
};
